import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { confirmEmail } from "../redux/slices/authSlice";

const ConfirmEmailPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userId = searchParams.get("userId");
  const token = searchParams.get("token");

  const { status, message, error } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState(false);

  useEffect(() => {
    if (status === "succeeded") {
      setLoading(false);
      setSuccess(true);
      setErrors(false);
    } else if (status === "failed") {
      setLoading(false);
      setSuccess(false);
      setErrors(true);
    }
  }, [status]);

  const handleConfirmEmail = () => {
    setLoading(true);
    setErrors(false);
    setTimeout(() => {
      dispatch(confirmEmail({ userId, token }));
    }, 2000);
  };

  return (
    <>
      <div className="main-wrapper authentication-wrapper">
        {/* <div className="p-4 text-center">
          
        </div> */}
        <div className="min-h-screen flex flex-col items-center justify-center flex-direction-col gap-4">
          <img
            src="assets/img/logo-dark.svg"
            alt="logo"
            className="img-fluid"
          />
          <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md relative">
            <img
              src="https://www.shutterstock.com/image-vector/email-messagingemail-marketing-campaign-600nw-1381873973.jpg"
              alt="A beautiful scenic view of a travel destination with mountains and a lake"
              className="absolute top-0 left-0 w-full h-40 object-cover rounded-t-lg"
            />
            <div className="pt-44">
              <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">
                Xác nhận Email
              </h2>
              {loading ? (
                <>
                  <div className="flex justify-center">
                    <i className="fas fa-spinner fa-spin text-4xl text-blue-500"></i>
                  </div>
                  <p className="text-lg font-medium mb-6 text-gray-700">
                    Hệ thống đang xác nhận email của bạn...
                  </p>
                </>
              ) : success ? (
                <div className="text-center">
                  <i className="fas fa-check-circle text-5xl text-green-500 mb-6"></i>
                  <p className="text-lg font-medium mb-6 text-gray-700">
                    {message}
                  </p>
                  <button
                    className="bg-gradient-to-r from-green-400 to-green-600 text-white px-6 py-3 rounded-full hover:from-green-500 hover:to-green-700 transition duration-300"
                    onClick={() => (window.location.href = "/login")}
                  >
                    Đi tới Đăng nhập
                  </button>
                </div>
              ) : errors ? (
                <div className="text-center">
                  <i className="fas fa-times-circle text-5xl text-red-500 mb-6"></i>
                  <p className="text-lg font-medium mb-6 text-gray-700">
                    {error}
                  </p>
                  <button
                    className="bg-gradient-to-r from-red-400 to-red-600 text-white px-6 py-3 rounded-full hover:from-red-500 hover:to-red-700 transition duration-300 mr-3"
                    onClick={handleConfirmEmail}
                  >
                    Thử lại
                  </button>
                  <button
                    className="bg-gradient-to-r from-gray-400 to-gray-600 text-white px-6 py-3 rounded-full hover:from-gray-500 hover:to-gray-700 transition duration-300"
                    onClick={() => (window.location.href = "/")}
                  >
                    Về trang chủ
                  </button>
                </div>
              ) : (
                <div className="text-center">
                  <p className="text-lg mb-6 text-gray-700">
                    Vui lòng xác nhận email của bạn để tiếp tục.
                  </p>
                  <button
                    className="bg-gradient-to-r from-blue-400 to-blue-600 text-white px-6 py-3 rounded-full hover:from-blue-500 hover:to-blue-700 transition duration-300"
                    onClick={handleConfirmEmail}
                  >
                    Xác nhận
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="coprright-footer">
          <p className="fs-14">
            Copyright &copy; 2025. All Rights Reserved,{" "}
            <a href="javascript:void(0);" className="text-primary fw-medium">
              DreamsTour
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default ConfirmEmailPage;
